// extracted by mini-css-extract-plugin
export default {"container":"container-xFTWl","favoriteTracksButton":"favoriteTracksButton-W4PqJ"};